const getSessionKey = (offerId: string) => `offer_flow_restored_${offerId}`;

export const useHasRestoredThisSession = (
    offerId: string | undefined
): { hasRestored: boolean; markRestored: () => void } => {
    const hasRestored =
        offerId !== undefined &&
        sessionStorage.getItem(getSessionKey(offerId)) === 'true';

    const markRestored = () => {
        if (offerId) {
            sessionStorage.setItem(getSessionKey(offerId), 'true');
        }
    };

    return { hasRestored, markRestored };
};
